import React from 'react';

/**
 * ResearcherSortSelect
 * - Controlled select for researcher sorting.
 * - Props:
 *   - sort: { order_by: string, order: 'asc'|'desc' }
 *   - onChange: (nextSort) => void
 *   - className: optional
 */
export default function ResearcherSortSelect({ sort = { order_by: 'date', order: 'desc' }, onChange, className = '' }) {
  const value = (() => {
    const ob = sort?.order_by;
    const od = sort?.order;
    if (ob === 'name') return `name:${od || 'asc'}`;
    if (ob === 'count') return 'count:desc';
    if (ob === 'hindex') return 'hindex:desc';
    if (ob === 'score') return 'score:desc';
    // default
    return 'date:desc';
  })();

  const handleChange = (e) => {
    const val = String(e.target.value);
    let next = { order_by: 'date', order: 'desc' };
    // if (val === 'date:desc') next = { order_by: 'date', order: 'desc' };
    if (val === 'name:asc') next = { order_by: 'name', order: 'asc' };
    else if (val === 'name:desc') next = { order_by: 'name', order: 'desc' };
    else if (val === 'count:desc') next = { order_by: 'count', order: 'desc' };
    else if (val === 'hindex:desc') next = { order_by: 'hindex', order: 'desc' };
    else if (val === 'score:desc') next = { order_by: 'score', order: 'desc' };
    if (typeof onChange === 'function') onChange(next);
  };

  return (
    <div className="sort min-[800px]:flex items-center gap-3 text-[13px] text-[#6C7687] font-medium">
      <p className="hidden min-[800px]:flex items-center gap-1">
        <img src={`${rmVars.themeUrl}images/filter_list_ico.png`} className="w-4 h-4" alt="sort icon" />
        Sort by
      </p>
      <select
        className="w-full py-2 px-3 bg-white border border-[#E4E8F1] rounded-lg appearance-none bg-no-repeat bg-size-[18px] bg-position-[98%] text-[13px] text-[#6C7687] outline-none lg:w-[184px]"
        style={{ backgroundImage: `url(${rmVars.themeUrl}images/expand_more_8D9AAF.png)` }}
        value={value}
        onChange={handleChange}
      >
        <option className="bg-white" value="date:desc">Recently Published</option>
        <option className="bg-white" value="score:desc">Relevance</option>
        <option className="bg-white" value="name:asc">Name : A to Z</option>
        <option className="bg-white" value="name:desc">Name : Z to A</option>
        <option className="bg-white" value="count:desc">Doc Count : highest first</option>
        <option className="bg-white" value="hindex:desc">H-index : highest first</option>
      </select>
    </div>
  );
}
